module.exports = __webpack_public_path__ + "media/images/qr-wb1-6656caa9133543fe94d98f7315486a92.png";